// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".backup-navigation a[data-v-6eb0b704] {\n  text-decoration: none;\n  height: 40px;\n  line-height: 40px;\n  display: block;\n  font-size: 14px;\n}\n.backup-navigation .router-link-active[data-v-6eb0b704] {\n  border-bottom: 3px solid #6353ef;\n  font-weight: bold;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
